// Gli URL che tornano dalla scena sono relativi alla sua radice quando non sono già
// assoluti. Vale per le texture e per le foto dei materiali: la risoluzione è una sola, e
// sta qui perché la usano file che non devono dipendere l'uno dall'altro.
// ASSOLUTO NON VUOL DIRE «http»: lo è anche un indirizzo che parte dalla radice del dominio, e lo
// sono `data:` e `blob:` — la forma di una texture appena scelta, che non è ancora un file da
// nessuna parte. Si riconosce lo SCHEMA, qualunque schema, invece di un prefisso solo: incollare
// la radice della scena davanti a un indirizzo che ce l'ha già produce un url che non esiste, e
// al posto dell'anteprima resta il vuoto.
export const ensureAbsolute = (rootUrl: string, url: string) => {
    if (!/^(?:\/|[a-z][a-z0-9+.-]*:)/i.test(url)) {
        return rootUrl + url;
    }
    return url;
};
